import {Component, inject, Signal} from '@angular/core';
import {AppConfigFacade} from '@selpia/app-config/data-access';
import {OptionsFacade} from '@selpia/options/data-access';
import {NavigationService} from '@selpia/data-batch/history-access';
import {DropdownComponent} from '@selpia/shared/ui';

@Component({
  selector: 'lib-feature-highlight-selector',
  imports: [
    DropdownComponent,
  ],
  templateUrl: './feature-highlight-selector.component.html',
  styleUrl: './feature-highlight-selector.component.css',
})
export class FeatureHighlightSelectorComponent {
  readonly #appConfigFacade = inject(AppConfigFacade);
  readonly #optionsFacade = inject(OptionsFacade);
  readonly #navigationService = inject(NavigationService);

  protected readonly isLoading: Signal<boolean> = this.#appConfigFacade.isLoading;

  protected readonly availableStrategies: Signal<string[]> = this.#appConfigFacade.highlightStrategies;
  protected readonly selectedStrategy: Signal<string | undefined> = this.#optionsFacade.colouringStrategy;

  updateStrategy(strategyName: string | undefined) {
    if (strategyName) {
      this.#navigationService.setColouringStrategy(strategyName);
    }
  }
}
